import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import ConfirmationUUIDManager from 'session/ConfirmationUUIDManager';

const PurchasedRedirect: React.FC<PurchasedRedirectProps> = ({
  redirectURL,
}) => {
  const history = useHistory();
  const { uuid } = useParams<{ uuid: string }>();

  if (uuid) {
    ConfirmationUUIDManager.setValue(uuid);
  }

  useEffect(() => {
    history.push({
      pathname: redirectURL,
      state: {
        uuid: uuid,
      },
    });
  }, [history, redirectURL, uuid]);

  return <></>;
};

export default PurchasedRedirect;

interface PurchasedRedirectProps {
  redirectURL: string;
}
